import { Restrictions, RawCadences, Cadences, RawRestriction, RestrictionsPayload } from 'common/types/filters';
import { CadencePeriod } from 'common/types/chart';

export const DEFAULT_CADENCES = {
  [CadencePeriod.WEEKLY]: [],
  [CadencePeriod.MONTHLY]: [],
  [CadencePeriod.QUARTERLY]: [],
  [CadencePeriod.BI_ANNUALLY]: [],
  [CadencePeriod.ANNUALLY]: [],
};

export const DEFAULT_RESTRICTIONS_PAYLOAD: RestrictionsPayload = {
  brands: [],
  countries: [],
  waves: [],
  cadences: DEFAULT_CADENCES,
};

const CADENCE_PERIOD_BY_API_KEY = {
  weeks: CadencePeriod.WEEKLY,
  months: CadencePeriod.MONTHLY,
  quarters: CadencePeriod.QUARTERLY,
  half_years: CadencePeriod.BI_ANNUALLY,
  years: CadencePeriod.ANNUALLY,
};

const MONTH_ABBR_PATTERN = /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\/(-?\d{4})$/;

const formatCadenceName = (name: string): string => {
  const monthMatch = name.match(MONTH_ABBR_PATTERN);
  if (monthMatch) {
    const date = new Date(`${monthMatch[1]} 1, ${monthMatch[2]}`);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }
  return name.replace('/', ' ');
};

/** This adapter is used in order to decouple API cadence keys from internal cadence periods */
const convertCadences = (cadences: RawCadences): Cadences => {
  const newCadences = {} as Cadences;

  for (const key in cadences) {
    const rawCadenceKey = key as keyof RawCadences;
    const cadenceKey = CADENCE_PERIOD_BY_API_KEY[rawCadenceKey];
    const entries = cadences[rawCadenceKey];

    newCadences[cadenceKey] = entries.map(entry => ({ ...entry, name: formatCadenceName(entry.name) }));
  }

  return { ...DEFAULT_CADENCES, ...newCadences };
};

export const normalizeRawRestrictions = (rawRestrictions: RawRestriction[]): Restrictions[] => {
  return rawRestrictions.map(raw => ({ ...raw, cadences: convertCadences(raw.cadences) }));
};

export const removeStudyFromRestrictions = (restrictions: Restrictions | undefined): RestrictionsPayload => {
  if (!restrictions) return { brands: [], countries: [], waves: [], cadences: DEFAULT_RESTRICTIONS_PAYLOAD.cadences };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { study_uuid: _, ...trimmedRestrictions } = restrictions;
  return trimmedRestrictions;
};
